/**
 * Visitor-facing source text with internal names taken out (2026-10-23).
 *
 * Public Look found /cities printing "Market Truth" and
 * "(market_metric, definition mt-v1, segment detached, region central-oregon)"
 * in its source notes. Those are names of our own tables and definitions, not
 * words a visitor can use. Every source line runs through this before it
 * renders, so a trace written with internal ids still reads in plain words.
 * The Oregon Data Share attribution is never removed.
 */
const INTERNAL_PAREN = /\s*\([^()]*\b(?:market_metric|mt-v\d+|stat_id|definition\s+mt|public\.[a-z_]+)\b[^()]*\)/gi

export function publicSourceText(text: string): string {
  if (!text) return text
  let out = text
    .replace(INTERNAL_PAREN, '')
    .replace(/\b(?:stat_id|geo_type|geo_slug|segment|window_months|definition_id|complete_through)=[^·|]*(?:·\s*)?/gi, '')
  out = out
    .replace(/\b(?:read )?(?:through|via|from) (?:the )?Market Truth(?: metric layer| fact definitions)?/gi, 'with Ryan Realty analysis')
    .replace(/\bMarket Truth(?: region row| row| cell)?\b/gi, 'Ryan Realty analysis')
    .replace(/\bpublic\.market_metric\b/gi, 'Ryan Realty analysis')
    .replace(/\bmarket_metric\b(?:\s+[a-z_]+(?::[a-z0-9:-]+)?)?/gi, 'Ryan Realty analysis')
    .replace(/,?\s*definition\s+mt-v\d+/gi, '')
    .replace(/\bmt-v\d+\b\s*/gi, '')
    .replace(/\bdetached (?:single-family )?(homes|houses)\b/gi, 'single-family $1')
    .replace(/\bRyan Realty analysis(?:[\s,]+Ryan Realty analysis)+/gi, 'Ryan Realty analysis')
    .replace(/\(\s*\)/g, '')
    .replace(/\s+([,.;:])/g, '$1')
    .replace(/ {2,}/g, ' ')
    .trim()
  return out
}
